var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-dashboard" },
    [
      _c("div", { attrs: { id: "FormList" } }, [
        _c("div", { staticClass: "header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "header-text" }, [
            _c("h1", [_vm._v(_vm._s(_vm.$t("form.forms")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("form.formsDesc")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _vm.loading
            ? _c("div", { staticClass: "loading-container" }, [
                _c("div", { staticClass: "loading-spinner" }),
                _vm._v(" "),
                _c("p", { staticClass: "loading-text" }, [
                  _vm._v("Formlar yükleniyor..."),
                ]),
              ])
            : _vm.formsWithColors.length > 0
            ? _c(
                "div",
                { staticClass: "form-grid" },
                _vm._l(_vm.formsWithColors, function (form) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value:
                            _vm.features.maxFormViewLimit &&
                            form.formViews >= _vm.features.maxFormViewLimit
                              ? {
                                  content:
                                    "Bu formunuzun görüntüleme limiti aşıldı. Lütfen yüksek plan seçiniz.",
                                  placement: "top",
                                  theme: "error",
                                }
                              : {},
                          expression:
                            "features.maxFormViewLimit && form.formViews >= features.maxFormViewLimit ? {\n                        content: 'Bu formunuzun görüntüleme limiti aşıldı. Lütfen yüksek plan seçiniz.',\n                        placement: 'top',\n                        theme: 'error'\n                    } : {}",
                        },
                      ],
                      key: form._id,
                      staticClass: "list-card",
                      class: {
                        selected:
                          _vm.selectedForm && _vm.selectedForm._id === form._id,
                        "limit-exceeded":
                          _vm.features.maxFormViewLimit &&
                          form.formViews >= _vm.features.maxFormViewLimit,
                      },
                      style: { "--border-color": form.color },
                      on: {
                        click: function ($event) {
                          return _vm.formId(form._id)
                        },
                      },
                    },
                    [
                      form.unreadCount
                        ? _c(
                            "div",
                            {
                              staticClass: "icon-section",
                              style: { backgroundColor: form.color },
                              attrs: { "data-count": form.unreadCount },
                            },
                            [
                              _c("i", { staticClass: "md-icon" }, [
                                _vm._v("article"),
                              ]),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "icon-section",
                              style: { backgroundColor: form.color },
                            },
                            [
                              _c("i", { staticClass: "md-icon" }, [
                                _vm._v("article"),
                              ]),
                            ]
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-section" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(form.title)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-section" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t("message.edit"),
                                  placement: "top",
                                },
                                expression:
                                  "{ content: $t('message.edit'), placement: 'top' }",
                              },
                            ],
                            staticClass: "action-btn edit",
                            on: {
                              click: function ($event) {
                                return _vm.editForm(form._id)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "md-icon" }, [
                              _vm._v("edit"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t("form.inbox"),
                                  placement: "top",
                                },
                                expression:
                                  "{ content: $t('form.inbox'), placement: 'top' }",
                              },
                            ],
                            staticClass: "action-btn inbox",
                            on: {
                              click: function ($event) {
                                return _vm.inboxForm(form._id)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "md-icon" }, [
                              _vm._v("inbox"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t("message.delete"),
                                  placement: "top",
                                },
                                expression:
                                  "{ content: $t('message.delete'), placement: 'top' }",
                              },
                            ],
                            staticClass: "action-btn delete",
                            on: {
                              click: function ($event) {
                                return _vm.showDeleteModal(form)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "md-icon" }, [
                              _vm._v("delete"),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "empty-state" }, [
                _c("div", { staticClass: "empty-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z",
                        },
                      }),
                      _vm._v(" "),
                      _c("polyline", { attrs: { points: "14,2 14,8 20,8" } }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: { x1: "16", y1: "13", x2: "8", y2: "13" },
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: { x1: "16", y1: "17", x2: "8", y2: "17" },
                      }),
                      _vm._v(" "),
                      _c("polyline", { attrs: { points: "10,9 9,9 8,9" } }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Henüz form oluşturmadınız")]),
                _vm._v(" "),
                _c("p", [_vm._v("Yeni bir form oluşturarak başlayın")]),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.selectedForm
        ? _c("div", { staticClass: "form-details" }, [
            _c("div", { staticClass: "details-header" }, [
              _c("h2", [_vm._v(_vm._s(_vm.selectedForm.title || "-"))]),
              _vm._v(" "),
              _c("div", { staticClass: "header-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "preview-btn",
                    on: {
                      click: function ($event) {
                        return _vm.viewForm(_vm.selectedForm._id)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "md-icon" }, [_vm._v("visibility")]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("form.formView")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "edit-btn",
                    on: {
                      click: function ($event) {
                        return _vm.editForm(_vm.selectedForm._id)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "md-icon" }, [_vm._v("edit")]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("form.formEdit")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-grid" }, [
              _c("div", { staticClass: "stat-card" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "stat-info" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.$t("form.totalResponse"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.total || 0)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "stat-info" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.$t("form.totalUnreadResponse"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.unreadCount || 0)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "stat-info" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.$t("form.totalReadResponse"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.readCount || 0)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "stat-info" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.$t("form.totalArchivedResponse"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.selectedForm.archivedCount || 0)),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("form.deleteFormConfirm"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteModal = false
              },
              confirm: _vm.confirmDelete,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-logo" }, [
      _c("span", { staticClass: "md-icon" }, [_vm._v("description")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon total" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("summarize")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon unread" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("mark_email_unread")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon read" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("mark_email_read")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon archived" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("inventory_2")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }